import React, { Component } from 'react';
import StarRatings from 'react-star-ratings';
 
class Foo extends Component {
    changeRating( newRating, name ) {
      this.setState({
        rating: newRating
      });
    }
 
    render() {
      // rating = 2;
      return (
        <StarRatings
          rating={this.state.rating}
          starRatedColor="blue"
          changeRating={this.changeRating}
          numberOfStars={6}
          name='rating'
          langue=''
        />
      );
    }
}
 
 
class Bar extends Component {
  render() {
    // aggregateRating = 2.35;
    return (
      <StarRatings
        rating={2}
        starDimension="20px"
        starSpacing="5px"
      />
    );
  }
}

export default StarRatings;


// WEBPACK FOOTER //
// ./src/components/StarRatings.js